import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import styles from "./LimitOrDeleteModal.module.css";
import { useTranslation } from "react-i18next";

function LimitReached({ show, handleClose }) {
  const { t } = useTranslation();
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton style={{ background: "#F5F4F4" }}>
          <Modal.Title>
            <div className={styles.modalHead}>
              <p>
                {t("ACTIVE_MEMBER")} <span>{t("LIMIT")}</span>
              </p>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.modalBody}>
            <p>
              {t("YOU_HAVE_REACHED_YOUR")}{" "}
              <span>{t("ACTIVE_MEMBER_LIMIT")}</span>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ background: "#F5F4F4" }}>
          <div className={styles.btnSection}>
            <button className={styles.close} onClick={handleClose}>
              {t("CLOSE")}
            </button>
            <button className={styles.delete} onClick={handleClose}>
              <p>
                {t("UPDATE")} <span>{t("PLAN")}</span>
              </p>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LimitReached;
